import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {SprintResponseModel} from 'models/sprint.model';
import {AppRootState} from 'store/appStore';

interface SprintState {
    selectedSprint: SprintResponseModel | null;
}

const initialState: SprintState = {
    selectedSprint: null,
};

const sprintSlice = createSlice({
    name: 'sprints',
    initialState,
    reducers: {
        setSelectedSprint: (state, action: PayloadAction<SprintResponseModel | null>) => {
            state.selectedSprint = action.payload;
        },
    },
});

export const {setSelectedSprint} = sprintSlice.actions;
export const sprintSliceReducer = sprintSlice.reducer;
export const sprintSelector = (rootState: AppRootState): SprintState => rootState.sprints;
